<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.role_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <piaf-breadcrumb heading="Roles List"/>

        <div class="d-flex flex-row">
            <span class="iconsminds-posterous mr-3 menu-icon-style"/>
            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,
                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum
                officiis quia quos rem totam vitae.
            </p>
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchRoles" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'Roles List'">
            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchRole">
                <template v-slot:cell(code)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(name)="data">
                    <span v-text="data.item.data.attributes.name"/>
                </template>

                <template v-slot:cell(updated_at)="data">
                    <span v-text="data.item.data.attributes.updated_at"/>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>
                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item @click="assignPermission(data.item)">
                            Assign Permissions
                        </b-dropdown-item>

                        <b-dropdown-item @click="editRole(data.item.role_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteRole(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>
        <RoleFormModal :edit="edit" @updated="tableKey++"/>

        <RolePermissionModal v-if="role" :role="role" mode="assign" @updated="tableKey++"/>

        <RoleDeletemodal v-if="role" mode="role" :role="role" @deleted-role="tableKey++"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import RoleFormModal from "./modals/RoleFormModal";
import RoleDeletemodal from "./modals/RoleDeletemodal";
import RolePermissionModal from "./modals/RolePermissionModal";

export default {
    name: "RolesList",

    components: {
        RoleFormModal,
        RoleDeletemodal,
        RolePermissionModal
    },

    data() {
        return {
            loading: true,
            edit: false,
            role: null,
            tableKey: 0,
        }
    },

    computed: {
        ...mapGetters({
            table_fields: 'getRoleTableFields',
            meta: 'getRolesMeta',
        }),
    },

    methods: {
        changeOrderBy(key, label) {
            this.meta.order_by = label;
            this.meta.sort_by = key;
        },

        searchRoles: _.debounce(function (event) {
            if (this.meta.search && this.meta.search.length >= 3) {
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            }
        }, 300),

        changePageSize(per_page) {
            this.meta.per_page = per_page;
        },

        refreshData() {
            this.$store.commit('resetRolesMeta');
            this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
        },

        changeSorting(event) {
            (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
        },

        fetchRole() {
            return this.$store.dispatch('fetchRole')
                .then(roles => {
                    return roles.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async assignPermission(role) {
            this.role = role;

            await this.$store.dispatch('fetchPermissions');

            setTimeout(() => {
                this.$bvModal.show('role_assign');
            }, 1);
        },

        editRole(role_id) {
            this.edit = true;

            this.$store.dispatch('fetchEditRole', role_id)
                .finally(response => {
                    this.$bvModal.show('role_form');
                });
        },

        deleteRole(role) {
            this.role = role;

            setTimeout(() => {
                this.$bvModal.show('role_delete');
            }, 1);
        },
    }
}
</script>

<style scoped>

</style>
